import React, {useEffect, useRef, useState} from 'react';
import type {ICarouselInstance} from 'react-native-reanimated-carousel';
import {
  Container,
  Content,
  PlacaList,
  ContentHeader,
  Footer,
  Subtitle,
  ContentBanners,
  Title,
  PlacaListTitlesContainer,
} from './styles';
import analytics from '@react-native-firebase/analytics';

import {Header} from '../../components/Interface/Headers/Header';
import Carousel from 'react-native-reanimated-carousel';
import {Button} from '../../components/Interface/Forms/Buttons/Button';
import {Dimensions} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import {useIsFocused, useNavigation} from '@react-navigation/native';
import {Placa} from '../../components/shared/Placa';
import {api} from '../../services/api';
import {Loading} from '../../components/Interface/Loadings/Loading';


import banner2vehicle from '../../assets/images/cadastro_placa/cadastro_placa_banner.webp';
import banner3vehicle from '../../assets/images/cadastro_placa/taxa_parcelamento_banner.webp';

import banner2vehiclemodal from '../../assets/images/cadastro_placa/cadastro_placa_modal.webp';
import banner3vehiclemodal from '../../assets/images/cadastro_placa/taxa_parcelamento_modal.webp';

import {Titles} from '../../components/Interface/Typographies/Titles';
import {NotFound} from '../../components/Interface/Search/NotFound';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';

import {BannerWithModal} from '../../components/shared/BannerWithModal';
import { useAuth } from '../../context/auth';

interface VehicleProps {
  id: {
    $oid: string;
  };
  renavam: string;
  detran: string;
  placa: string;
  documento: string;
  active: boolean;
  person: {
    id: string;
    name: string;
    email: string;
    cpf: string;
    phone: string;
  };
  banners: {
    id: number;
    imagemUrl: any;
    title: string;
    texto: string;
    imageModal: any;
  };
}

export function Vehicles() {
  const navigation = useNavigation();

  const {isLogged} = useAuth();

  useEffect(() => {
    if (!isLogged) {
      navigation.navigate('Home');
    }
  }, [isLogged]);

  const [autoplay, setAutoplay] = useState(true);
  const banners = [
    /*
      id: 1,
      imageUrl: banner1vehicle,
      texto:
        'A cada pessoa indicada que parcelar utilizando o Baratão, você ganha dinheiro através das baratinhaZ.',
      imageModal: banner1vehicleModal,
      showIndiqGanhe: true,
    },**/
    {
      id: 2,
      imageUrl: banner2vehicle,
      title: 'O que você ganha ao cadastrar sua placa?',
      texto: '',
      imageModal: banner2vehiclemodal,
      showCadPlaca: true,
      steps: [
        {
          id: 1,
          texto:
            'BaratinhaZ:  Cada placa cadastrada significa mais BaratinhaZ para você. Essas nossas pontuações podem ser acumuladas e utilizadas em diversas oportunidades, como descontos em combustíveis, produtos e serviços em nossa rede de parceiros.',
        },
        {
          id: 2,
          texto:
            'Descontos no Parcelamento de Multas: Com o cadastro da sua placa, você terá acesso a descontos especiais no parcelamento de suas multas de trânsito. Economize dinheiro e resolva suas pendências financeiras de forma conveniente.',
        },
        {
          id: 3,
          texto:
            'Alerta de Multas: Mantenha-se informado sobre possíveis infrações de trânsito. Nosso aplicativo enviará alertas sempre que detectar uma multa associada à sua placa, permitindo que você aja rapidamente para evitar surpresas desagradáveis.',
        },
      ],
    },
    {
      id: 3,
      imageUrl: banner3vehicle,
      title: 'Descubra como podemos simplificar sua vida ',
      texto: 'Texto do banner 3',
      imageModal: banner3vehiclemodal,
      steps: [
        {
          id: 1,
          texto:
            ' Com o Baratão Combustíveis, você pode parcelar seus débitos com a menor taxa do Brasil, garantindo economia e conveniência para suas finanças.',
        },
        {
          id: 2,
          texto:
            'Mais Segurança nas Transações. Priorizamos a segurança dos nossos usuários. Utilizamos as mais avançadas medidas de segurança para proteger suas transações e informações pessoais.',
        },
        {
          id: 3,
          texto:
            'Não perca tempo em filas ou burocracias. Com o Baratão Combustíveis, você pode quitar seus débitos de forma rápida e simples, direto do seu dispositivo móvel.',
        },
        {
          id: 4,
          texto:
            'Suporte com Excelente Atendimento. Nossa equipe de suporte está disponível para fornecer assistência e orientação em todas as etapas do processo, garantindo uma experiência tranquila e satisfatória.',
        },
      ],
    },
  ];
  const [isLoading, setIsLoading] = useState(false);
  const isFocused = useIsFocused();

  const [data, setData] = useState<VehicleProps[]>([] as VehicleProps[]);

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);

    async function fetchVehicles() {
      try {
        const response = await api.get('/veiculosCadastrados');

        if (response.data) {
          if (isMounted) {
            setData(response.data);
            isMounted = false;
          }
        }
      } catch {
      } finally {
        setIsLoading(false);
      }
    }

    fetchVehicles();

    return () => {
      isMounted = false;
    };
  }, [isFocused]);

  async function ativaVeiculo(id: string) {
    try {
      const response = await api.post('/ativaVeiculo', {
        id,
      });

      if (response.data) {
        const updatedData = data.map(item => {
          if (item.id.$oid === id) {
            return {...item, active: true};
          }
          return item;
        });
        analytics().logEvent('ativa_veiculo_tela_veiculos');
        setData(updatedData);
      }
    } catch {
    } finally {
      setIsLoading(false);
    }
  }

  async function desativaVeiculo(id: string) {
    try {
      const response = await api.post('/desativaVeiculo', {
        id,
      });

      if (response.data) {
        const updatedData = data.map(item => {
          if (item.id.$oid === id) {
            return {...item, active: false};
          }
          return item;
        });
        analytics().logEvent('desativa_veiculo_tela_veiculos');
        setData(updatedData);
      }
    } catch {
    } finally {
      setIsLoading(false);
    }
  }

  const toggleSwitch = (data: VehicleProps) => {
    if (data.active) {
      desativaVeiculo(data.id.$oid);
    }

    if (!data.active) {
      ativaVeiculo(data.id.$oid);
    }
  };

  const carouselRef = useRef<ICarouselInstance>(null);

  useEffect(() => {
    analytics().logEvent('tela_veiculos_alerta_multas');
  }, []);

  return (
    <Container>
      {isLoading && <Loading />}
      <Header icon="chevron-left" />

      <Content>
        <ContentHeader>
          <Titles
            title="O alerta de multas é gratuito, ajuda você a economizar e ganhar
            baratinhaZ"
          />
        </ContentHeader>
        <ContentBanners>
          <Carousel
            ref={carouselRef}
            data={banners}
            renderItem={({item}) => (
              <BannerWithModal
                data={item}
                key={item.id}
                onOpenModal={() => setAutoplay(false)}
                onCloseModal={() => setAutoplay(true)}
              />
            )}
            width={Dimensions.get('window').width}
            height={RFValue(50)}
            autoPlay={autoplay}
            autoPlayInterval={3500}
            loop={true}
          />
        </ContentBanners>
        <PlacaListTitlesContainer>
          <Title>Meus veículos</Title>
          <Subtitle>Você pode cadastrar até 5 placas</Subtitle>
        </PlacaListTitlesContainer>
        {data.length > 0 ? (
          <PlacaList>
            {data.map(vehicle => (
              <Placa
                key={vehicle.id.$oid}
                action={() =>
                  navigation.navigate('Vehicle', {
                    data: vehicle,
                  })
                }
                isEnabled={vehicle.active}
                onValueChange={() => toggleSwitch(vehicle)}
                subtitle={vehicle.renavam}
                title={vehicle.placa}
              />
            ))}
          </PlacaList>
        ) : (
          !isLoading && (
            <NotFound
              title="Nenhum veículo cadastrado"
              text="Cadastre AGORA um veículo e ative o alerta de multas."
              style={{
                marginTop: -RFPercentage(5),
              }}
            />
          )
        )}
      </Content>

      <Footer>
        <SafeAreaView>
          <Button
            title="Adicionar veículo"
            enabled
            onPress={() => navigation.navigate('AddVehicle')}
          />
        </SafeAreaView>
      </Footer>
    </Container>
  );
}
